module.exports = __webpack_public_path__ + "static/chatMobile-fb22a695eadaeaea791f8a3b2bdc1982.png";